import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useMainStore } from '@/modules/shared/stores/main.store'

import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '../stores/order-form.store'
import type { IOrderFormJson } from '../types/order-form-json.type'
import { useOperationOrder } from './use-operations-order.hook'
import { useOrderFormClearData } from './use-order-form-clear-data.hook'
import useOrderFormParams from './use-order-form-params.hook'
import { useLoadOrder } from './use-load-order.hook'
import { useOrdersSearchStore } from '../stores/order-search.store'

type TModalType = 'selectCompany'

export const useOrderForm = () => {
  const [typeModal, setTypeModal] = useState<TModalType | undefined>()
  const [isOpenModalSelectCompany, setIsOpenModalSelectCompany] =
    useState(false)

   useLoadOrder()
  const navigate = useNavigate()

  const { initialLocationForOrder } = useMainStore()
  const { setInitialLocationForOrder } = useMainStore().actions

  const { setCompanyId } = useOperationOrder()

  const { clearAllDataOfOrder } = useOrderFormClearData()

  const { setConfirmation, setCloseConfirmation } = useMainStore().actions
  const { setJsonOrderForm } = useOrderFormStoreActions()
  const { jsonOrderForm, operationType } = useOrderFormStore()

  const { hasClientSelected, isViewOrder } = useOrderFormParams()

  const orderId = jsonOrderForm?.idPedidoCel

  const {
    actions: { setFilters },
  } = useOrdersSearchStore()

  const handleBackPage = useCallback(async () => {
    if (!hasClientSelected || isViewOrder) {
    navigate('/pedidos')
      clearAllDataOfOrder()
      return
    }
    setConfirmation({
      title: 'Atenção',
      isOpen: true,
      message:
        operationType === 'edit'
          ? 'Deseja sair sem salvar as alterações?'
          : 'Deseja sair sem salvar o pedido?',
      onClose: () => {
        setCloseConfirmation()
      },
      onConfirm: () => {
        setFilters(undefined)

        if (operationType === 'edit') {
          setFilters(undefined)
        }

        setCloseConfirmation()
        clearAllDataOfOrder()

        if (initialLocationForOrder) {
          navigate(initialLocationForOrder)
          setInitialLocationForOrder(undefined)
          return
        }

        navigate('/pedidos')
      },
    })
  }, [])

  const handleSelectCompany = (companyId: string) => {
    const newJsonWithCompany: IOrderFormJson = {
      ...jsonOrderForm,
      fkEmpresa: companyId,
    }

    setJsonOrderForm(newJsonWithCompany)
    setCompanyId(companyId)
    setTypeModal(undefined)
  }

  return {
    typeModal,
    isViewOrder,
    handleBackPage,
    hasClientSelected,
    hasProducts: jsonOrderForm?.itemsCalculo?.length > 0,
    handleSelectCompany,
    orderId: orderId || '',
    isOpenModalSelectCompany,
    setIsOpenModalSelectCompany,
  }
}
